import { formatDate } from './helpers';

export function saveAsJson(object: unknown, filename: string) {
  const contentType = 'application/json;charset=utf-8;';
  const fileData = JSON.stringify(object);
  const blob = new Blob([fileData], { type: contentType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}-${formatDate(new Date())}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function readFromLocalJsonFile(
  event: React.ChangeEvent<HTMLInputElement>,
  handler: (...args: any) => void
): void {
  if (!event) return;
  const file =
    event?.target?.files && event.target.files.length > 0
      ? event.target.files[0]
      : null;

  const reader = new FileReader();
  reader.onload = (e) => {
    const result = e?.target?.result;
    console.log(result);

    if (typeof result === 'string') {
      const projectData = JSON.parse(result);
      handler(projectData);
    }
  };
  if (file !== null) {
    reader.readAsText(file);
  } else {
    // Handle the case where file is null
    console.error('No file selected');
  }
}
